import { render, staticRenderFns } from "./DenominationsComposition.vue?vue&type=template&id=542ea619&scoped=true"
import script from "./DenominationsComposition.vue?vue&type=script&lang=ts"
export * from "./DenominationsComposition.vue?vue&type=script&lang=ts"
import style0 from "./DenominationsComposition.vue?vue&type=style&index=0&id=542ea619&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542ea619",
  null
  
)

export default component.exports